import { IconName } from "@seneca/senekit";

import { SubjectGB } from "features/common/subjects/consts";

type SubjectIconMap = {
  [subject in SubjectGB]: IconName;
};

export const subjectIconMap: SubjectIconMap = {
  [SubjectGB.astronomy]: "planet",
  [SubjectGB.archeology]: "scroll",
  [SubjectGB.ancientHistory]: "scroll",
  [SubjectGB.ancientLanguages]: "scroll",
  [SubjectGB.agriculture]: "grains",
  [SubjectGB.artAndDesign]: "palette",
  [SubjectGB.biology]: "dna",
  [SubjectGB.business]: "money",
  [SubjectGB.childCare]: "baby",
  [SubjectGB.citizenship]: "group",
  [SubjectGB.classicalCivilisation]: "peoplePair",
  [SubjectGB.coding]: "coding",
  [SubjectGB.construction]: "hammer",
  [SubjectGB.combinedScience]: "atom",
  [SubjectGB.computerScience]: "cpu",
  [SubjectGB.chemistry]: "flask",
  [SubjectGB.designTechnology]: "ruler",
  [SubjectGB.digital]: "desktop",
  [SubjectGB.education]: "student",
  [SubjectGB.engineering]: "gearFine",
  [SubjectGB.electronics]: "circuitry",
  [SubjectGB.dance]: "musicNotes",
  [SubjectGB.drama]: "maskHappy",
  [SubjectGB.economics]: "money",
  [SubjectGB.english]: "scroll",
  [SubjectGB.englishLanguage]: "books",
  [SubjectGB.englishLiterature]: "chatCircleText",
  [SubjectGB.englishLiteratureQuotations]: "bookOpenText",
  [SubjectGB.environmentalScience]: "tree",
  [SubjectGB.film]: "filmReel",
  [SubjectGB.functionalSkills]: "lightBulb",
  [SubjectGB.foodPreparationAndNutrition]: "forkKnife",
  [SubjectGB.french]: "translate",
  [SubjectGB.german]: "translate",
  [SubjectGB.geography]: "globeHemisphereWest",
  [SubjectGB.geology]: "mountains",
  [SubjectGB.hairAndBeauty]: "shower",
  [SubjectGB.healthAndSocialCare]: "handHeart",
  [SubjectGB.hospitality]: "bed",
  [SubjectGB.history]: "scroll",
  [SubjectGB.law]: "gavel",
  [SubjectGB.maths]: "mathOperations",
  [SubjectGB.music]: "musicNotes",
  [SubjectGB.mediaStudies]: "television",
  [SubjectGB.nonVerbalReasoning]: "strategy",
  [SubjectGB.physics]: "magnet",
  [SubjectGB.psychology]: "brain",
  [SubjectGB.politics]: "gavel",
  [SubjectGB.politicalStudies]: "gavel",
  [SubjectGB.pshe]: "brain",
  [SubjectGB.philosophy]: "scales",
  [SubjectGB.physicalEducation]: "personsArmsSpread",
  [SubjectGB.religiousStudies]: "church",
  [SubjectGB.science]: "atom",
  [SubjectGB.spanish]: "translate",
  [SubjectGB.sociology]: "peoplePair",
  [SubjectGB.statistics]: "chart",
  [SubjectGB.sciencePracticals]: "lightning",
  [SubjectGB.verbalReasoning]: "chatsCircle"
};

export function getSubjectIcon(subject?: string): IconName {
  if (!!subject && subject in subjectIconMap)
    return subjectIconMap[subject as SubjectGB];
  return "books";
}
